var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRefreshlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.75,
    height: 19.869,
    viewBox: "0 0 16.75 19.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_refreshlist",
    d: "M5.625,15.75,9,13.5v.991A5.606,5.606,0,0,0,11.033,4.349L13,3.036A7.857,7.857,0,0,1,9,16.784V18ZM0,9A7.875,7.875,0,0,1,6.75,1.221V0l3.375,2.25L6.75,4.5V3.542A5.582,5.582,0,0,0,4.717,13.651l-1.97,1.313A7.855,7.855,0,0,1,0,9Zm4.447,3.287V10.609h6.82v1.679Zm0-2.465V8.143h6.82V9.822Zm0-2.465V5.678h6.82V7.356Z",
    transform: "translate(0.5 0.934)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshlist);
export default __webpack_public_path__ + "static/media/icon_refreshlist.ebcc3dc06769568578e186b6bc74af7c.svg";
export { ForwardRef as ReactComponent };